import { FETCH_REGIONS } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_REGIONS:
			return action.payload;
		default:
			return state;
	}
};
